import classnames from 'classnames'
import Modal from '@components/Modal'
import Button from '@components/Button'

import styles from './styles.module.scss'

const CancelSubscriptionModal = ({ closeModal }) => (
    <Modal size="small" onClose={closeModal} className={styles.cancelModal}>
        <h5 className={styles.title}>
            <T>dashboard.subscriptions.cancel.modal.title</T>
        </h5>
        <div>
            <T>dashboard.subscriptions.cancel.modal.content</T>
        </div>
        <div className={classnames('d-flex', styles.buttons)}>
            <Button block btnStyle="outline" onClick={closeModal}>
                <T>dashboard.subscriptions.modal.close</T>
            </Button>
            <Button block btnStyle="primary" href="/contact-us" target="_blank">
                <T>dashboard.subscriptions.cancel.modal.contact</T>
            </Button>
        </div>
    </Modal>
)
export default CancelSubscriptionModal
